/**
 * PDF Export Utility
 *
 * Exports the report preview to PDF using html2canvas + jsPDF
 */

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export async function exportReportToPDF(
  institutionName: string,
  period: string
): Promise<void> {
  const reportElement = document.querySelector('.report-preview-container');

  if (!reportElement) {
    throw new Error('Report preview element not found');
  }

  try {
    // Show loading state
    const originalCursor = document.body.style.cursor;
    document.body.style.cursor = 'wait';

    // Capture the report as canvas
    const canvas = await html2canvas(reportElement as HTMLElement, {
      scale: 2, // Higher quality
      useCORS: true,
      logging: false,
      windowWidth: 1200, // Fixed width for consistency
    });

    // Convert canvas to PDF
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    // Calculate dimensions to fit A4
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const canvasAspectRatio = canvas.height / canvas.width;
    const imgHeight = pdfWidth * canvasAspectRatio;

    let heightLeft = imgHeight;
    let position = 0;

    // Add first page
    pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
    heightLeft -= pdfHeight;

    // Add additional pages if content is longer than one page
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    // Generate filename
    const filename = `Reporte_${institutionName.replace(/\s+/g, '_')}_${period}.pdf`;

    // Save the PDF
    pdf.save(filename);

    // Restore cursor
    document.body.style.cursor = originalCursor;

    console.log(`PDF exported successfully: ${filename}`);
  } catch (error) {
    console.error('Error exporting PDF:', error);
    throw new Error('Failed to export PDF. Please try again.');
  }
}
